module.exports = __webpack_public_path__ + "static/media/icon-laboratory.bf094457.svg";